import { createCRUDHook } from './createCRUDHook';
import { SizeDto } from 'utils/models';
import { TLKP_SIZE } from './apiEndPoints';

// Create the CRUD hook - that's it!
const { Context, useManager, useConsumer } = createCRUDHook<SizeDto>({
  entityName: 'Size',
  endpoint: TLKP_SIZE,
});

export const SizeContext = Context;
export const useSizeManager = useManager;
export const useSize = useConsumer;
